(function () {
  function isEnabled(value, fallback) {
    if (value === undefined || value === null || value === '') return fallback;
    return value === 'true';
  }

  function configureProductCard(card, section) {
    if (!card) return;

    var imageRatio = section.dataset.cardImageRatio || 'portrait_3_4';
    var image = card.querySelector('.product-card-image');
    if (image) {
      Array.from(image.classList).forEach(function (className) {
        if (className.indexOf('product-card-image--') === 0 && className !== 'product-card-image--video' && className !== 'product-card-image--has-hover') {
          image.classList.remove(className);
        }
      });
      image.classList.add('product-card-image--' + imageRatio);
    }

    var showTitle = isEnabled(section.dataset.cardShowTitle, true);
    var showPrice = isEnabled(section.dataset.cardShowPrice, true);
    var showVendor = isEnabled(section.dataset.cardShowVendor, false);
    var showVariants = isEnabled(section.dataset.cardShowVariantOptions, true);
    var showBadges = isEnabled(section.dataset.cardShowBadges, true);
    var showQuickView = isEnabled(section.dataset.cardShowQuickView, true);

    card.dataset.productCardHoverEffect = section.dataset.cardHoverEffect || 'fade';
    card.dataset.productCardContentAlignment = section.dataset.cardContentAlignment || 'left';
    card.dataset.productCardVariantStyle = section.dataset.cardVariantStyle || 'hover_reveal';
    card.dataset.productCardVariantOverlap = section.dataset.cardVariantOverlap || 'true';
    card.dataset.productCardMobileQuickViewMode = showQuickView
      ? (section.dataset.cardMobileQuickViewMode || 'direct')
      : 'disabled';
    card.dataset.productCardShowTitle = String(showTitle);
    card.dataset.productCardShowPrice = String(showPrice);
    card.dataset.productCardShowVendor = String(showVendor);
    card.dataset.productCardShowVariantOptions = String(showVariants);
    card.dataset.productCardShowBadges = String(showBadges);
    card.dataset.productCardShowQuickView = String(showQuickView);
    card.style.setProperty('--product-card-content-alignment', section.dataset.cardContentAlignment || 'left');

    var variantTray = card.querySelector('[data-product-card-variant-tray]');
    if (!showVariants) {
      card.classList.remove('product-card--has-variant-tray', 'product-card--variant-only');
      if (variantTray) variantTray.hidden = true;
    } else if (variantTray) {
      card.classList.add('product-card--has-variant-tray');
      card.classList.toggle('product-card--variant-only', !showPrice);
    }

    var metaSlot = card.querySelector('.product-card__meta-slot');
    if (metaSlot) metaSlot.hidden = !showPrice && (!showVariants || !variantTray);
  }

  function bindRecentlyViewed(section) {
    if (!section || section.dataset.recentlyViewedBound === 'true') return;
    section.dataset.recentlyViewedBound = 'true';

    var key = 'axiom_recently_viewed';
    var current = section.dataset.currentHandle || '';
    var limit = parseInt(section.dataset.limit || '4', 10);
    var grid = section.querySelector('[data-recently-viewed-grid]');
    var empty = section.querySelector('[data-recently-viewed-empty]');
    var root = (window.Axiom && window.Axiom.routes && window.Axiom.routes.root) || '/';
    var cardView = section.dataset.cardAutoplayVideo === 'true' ? 'card-video' : 'card';
    var handles = [];

    try { handles = JSON.parse(localStorage.getItem(key) || '[]'); } catch(e) { handles = []; }
    handles = handles.filter(function (handle) { return handle && handle !== current; });
    if (current) {
      localStorage.setItem(key, JSON.stringify([current].concat(handles).slice(0, 12)));
    }
    handles = handles.slice(0, limit);
    if (!grid || !handles.length) {
      if (empty) empty.hidden = false;
      return;
    }

    Promise.all(handles.map(function (handle) {
      return fetch(root + 'products/' + encodeURIComponent(handle) + '?view=' + cardView, { headers: { 'Accept': 'text/html' } })
        .then(function (response) { return response.ok ? response.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (cards) {
      var html = cards.filter(Boolean).join('');
      if (!html) {
        if (empty) empty.hidden = false;
        return;
      }
      grid.innerHTML = html;
      grid.querySelectorAll('[data-product-card]').forEach(function (card) {
        configureProductCard(card, section);
      });
      if (window.Axiom && typeof window.Axiom.revealElements === 'function') {
        window.Axiom.revealElements(grid, {
          trigger: 'manual',
          reset: true,
          stagger: 64
        });
      }
      document.dispatchEvent(new CustomEvent('axiom:section-rendered', { detail: { container: section } }));
    });
  }

  function init() {
    document.querySelectorAll('[data-recently-viewed]').forEach(bindRecentlyViewed);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
